@let configs = this.configs();
@if (configs.length > 0) {
  <div
    class="fixed z-[999] top-0 left-0 w-full h-full"
    (click)="$event.stopPropagation()"
    (keydown)="$event.stopPropagation()"
    (keyup)="$event.stopPropagation()"
  >
    <div
      class="modal-overlay"
      animate.enter="overlay-enter"
      (click)="$event.stopPropagation(); service.dismiss(activeConfig()?.id ?? '')"
      (keydown)="$event.stopPropagation()"
      (keyup)="$event.stopPropagation()"
    ></div>
    @for (config of configs; track config.id) {
      @if (config === activeConfig()) {
        <soft-modal
          [animate.enter]="isMobile() ? 'modal-enter-mobile' : 'modal-enter'"
          [animate.leave]="isMobile() ? 'modal-leave-mobile' : 'modal-leave'"
          class="z-[1000] relative"
          [config]="config"
          [active]="config === activeConfig()"
        ></soft-modal>
      }
    }
  </div>
}
